import { Box } from '@mui/material';
import { Layout, Loader } from 'components';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import TermsOfUseApiService from '../../api/TermsOfUseApiService';
import { loadDocumentsAction } from '../../store/actions/documentsActions';
import { useAppState } from '../../store/Provider';
import './Documents.scss';
import DocumentsTabs from './DocumentsTabs/DocumentsTabs';

const Documents: React.FC = () => {
  const [t] = useTranslation();
  const { state, dispatch } = useAppState();
  const { documents } = state;

  const fetchTermsOfUse = async () => {
    const { data } = await TermsOfUseApiService.get();
    dispatch(loadDocumentsAction([data.presignedUri]));
  };

  useEffect(() => {
    fetchTermsOfUse();
  }, []);

  return (
    <Layout name={t('Docs')} path="/documents">
      <Box className="documents-page">
        <DocumentsTabs />
        <Box className="iframe-container">
          {documents.documents && documents.documents?.length > 0 ? (
            <>
              {documents.documents?.map((document) => (
                <iframe key={document} id="iframe" className="iframe" src={document} title="cgi" />
              ))}
            </>
          ) : (
            <Loader />
          )}
        </Box>
      </Box>
    </Layout>
  );
};

export default Documents;
